<template>
  <h2 v-if="data.firstOfType" class="group-title ml-4 md:ml-0">{{ data.groupTitle }}</h2>
  <router-link :class="['new-overview-item', data.class, {'last': data.lastOfType} ]" :to="data.to">
    <span v-if="data.status" class="status">{{data.status}}</span>
    <div class="details">
      <time v-if="data.startTime" class="from">{{data.startTime}}</time>
      <time v-if="data.endTime" class="to">{{data.endTime}}</time>
      <span class="title">{{data.title}}</span>
      <span class="subtitle">{{data.subtitle}}</span>
      <div v-if="data.description" :class="['bottom', !data.status && 'indent']">
        <span class="description">{{data.description}}</span>
        <span class="trailing">{{data.trailing}}</span>
      </div>
      <p-icon v-if="data.icon" class="icon"
                 :icon-name="data.icon" color="blue"/>
    </div>
  </router-link>
</template>

<script lang="ts" setup>
defineProps<{
  data: newOverviewItem
}>();
</script>

<style lang="scss">
.group-title {
  text-transform: capitalize;
  font-size: 13px;
  color: var(--pidz-body-text);
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 14px;
}

.new-overview-item {
  text-decoration: none;

  display: block;
  background: var(--pidz-white);
  padding: 12px;
  color: var(--pidz-body-text);
  border-bottom: 1px solid var(--pidz-grey-light);
  -webkit-tap-highlight-color: transparent;

  &.last {
    box-shadow: var(--shadow-light);
    border-bottom: 0;
  }

  .details {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 8px;

    .from {
      grid-row:  1;
      grid-column: 1;
      }

    .to {
      grid-row: 2;
      grid-column: 1;
    }

    .title {
      font-weight: bold;
      grid-row: 1;
      padding-right: 40px;
    }

    .subtitle {
      grid-row: 2;
    }

    .bottom {
      display: grid !important;
      grid-column: span 2;
      grid-row: 3;

      &.indent {
        grid-column: 2;
      }
    }

    * {
      align-self: center;
    }
  }

  .status {
    font-style: italic;
    display: inline-block;
    margin-bottom: 8px;
  }
  .status, time, .description, .trailing {
    color: var(--pidz-grey-dark);
    font-size: 13px;
  }

  .bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    justify-content: space-between;
    grid-template-rows: 30px auto;

    & > * {
      justify-self: end;
    }

    :first-child {
      justify-self: start;
    }
  }

  &.success, &.warning, &.error, &.info {
    border-left: 5px solid;
  }

  &.success { border-left-color: var(--pidz-green) };
  &.warning { border-left-color: var(--pidz-orange) };
  &.error { border-left-color: var(--pidz-red) };
  &.info { border-left-color: var(--pidz-blue) };

  position: relative;

  .icon {
    color: var(--pidz-blue);
    position: absolute;
    width: var(--size);
    height: var(--size);
    top: 12px;
    right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 24px;
    }
  }
}
</style>
